import { render, staticRenderFns } from "./QRCodeDetail.vue?vue&type=template&id=bb850b5a&scoped=true&"
import script from "./QRCodeDetail.vue?vue&type=script&lang=js&"
export * from "./QRCodeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb850b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
